import Subheader from './Subheader';
export default Subheader;



// WEBPACK FOOTER //
// ./src/js/Subheaders/index.js